import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  inject,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalShellComponent } from '@automatick/shared-presentation-ng';
import { ButtonDirective } from '@seech/controls-ng';
import { ModalService } from '@seech/ux-ng';

export type ConfirmModalVariant = 'primary' | 'danger' | 'warning';
export type ConfirmModalResult = string | boolean | null;

export interface ConfirmModalConfig {
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: ConfirmModalVariant;
  /** When set, shows a text input pre-filled with this value. */
  inputValue?: string;
  inputPlaceholder?: string;
}

@Component({
  selector: 'app-confirm-modal',
  standalone: true,
  imports: [ButtonDirective, FormsModule, ModalShellComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './confirm-modal.component.html',
  styleUrl: './confirm-modal.component.scss',
})
export class ConfirmModalComponent implements OnInit {
  private readonly modalService = inject(ModalService);

  @Input() title = 'Confirm';
  @Input() message = '';
  @Input() confirmLabel = 'Confirm';
  @Input() cancelLabel = 'Cancel';
  @Input() variant: ConfirmModalVariant = 'primary';
  @Input() inputValue: string | undefined;
  @Input() inputPlaceholder = '';

  editValue = '';
  private closeRequested = false;

  get hasInput(): boolean {
    return this.inputValue !== undefined;
  }

  ngOnInit(): void {
    if (this.inputValue !== undefined) {
      this.editValue = this.inputValue;
    }
  }

  onConfirm(): void {
    this.close(this.hasInput ? this.editValue : true);
  }

  onCancel(): void {
    this.close(null);
  }

  onInputKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.onConfirm();
    }
  }

  private close(result: ConfirmModalResult): void {
    if (this.closeRequested) {
      return;
    }

    this.closeRequested = true;
    this.modalService.close(null, result);
  }
}
